module.exports = __webpack_public_path__ + "static/media/summon-demi.8f909bfa.png";